function initMtProduct() {
  var root = document.querySelector('[data-mt-product]');
  if (!root) return;

  // Gallery: click a thumbnail to swap the main image.
  var mainImg = root.querySelector('[data-mt-main-image]');
  var thumbs = root.querySelectorAll('[data-mt-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = thumb.dataset.full;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    });
  });

  // Variants: only present when the product has more than the default variant.
  var variantsScript = root.querySelector('[data-mt-variants]');
  if (!variantsScript) return;

  var variants;
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (e) {
    return;
  }

  var optionGroups = root.querySelectorAll('[data-mt-option-index]');
  var variantIdInput = root.querySelector('[data-mt-variant-id]');
  var priceNow = root.querySelector('.mt-product-price-now');
  var priceWas = root.querySelector('.mt-product-price-was');
  var addButton = root.querySelector('[data-mt-add-button]');
  var addText = root.querySelector('[data-mt-add-text]');

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD' });
  }

  function selectedOptions() {
    var selected = [];
    optionGroups.forEach(function (group) {
      var active = group.querySelector('.mt-option-value.is-active');
      selected.push(active ? active.dataset.mtOptionValue : null);
    });
    return selected;
  }

  function findVariant() {
    var selected = selectedOptions();
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
  }

  function updateUI() {
    var variant = findVariant();
    if (!variant) return;
    variantIdInput.value = variant.id;
    if (priceNow) priceNow.textContent = money(variant.price);
    if (priceWas) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceWas.textContent = money(variant.compare_at_price);
        priceWas.style.display = '';
      } else {
        priceWas.style.display = 'none';
      }
    }
    if (variant.available) {
      addButton.removeAttribute('disabled');
      if (addText) addText.textContent = addButton.dataset.mtAddLabel || addText.textContent;
    } else {
      addButton.setAttribute('disabled', 'disabled');
    }
  }

  optionGroups.forEach(function (group) {
    group.querySelectorAll('.mt-option-value').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.mt-option-value').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        updateUI();
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initMtProduct();
});
